// extracted by mini-css-extract-plugin
export default {"wrap":"VG-z","subtitle":"WG-z","contentWrap":"XG-z","imgWrap":"YG-z","heading":"ZG-z","copy":"_G-z"};